import React, { Component } from 'react';
import { connect } from "react-redux";
import { postConfirm } from '../../Core/User/Confirm/action';
import { postCall } from '../../Core/User/Call/action';
import CountdownTimer from './CountdownTimer';
import Loader from '../Loader';
import Logo from '../../Assets/Images/logo.png';
import styles from '../../Assets/Styles/Components/login/Login.module.css';

class LoginConfirm extends Component {
	seconds = 59;

	constructor() {
		super();
		this.state = {};
	}

	onConfirm = () => {
		// TODO: Call redux action
		const {
			password, phone, back, callConfirm,
		} = this.props;
		const search = Object.fromEntries(new URLSearchParams(window.location.search.substring(1)));
		const body = {};
		const urlParams = new URLSearchParams(search);
		const params = Object.fromEntries(urlParams);
		if (params.utm_source) {
			body.utm_source = params.utm_source;
		}
		if (params.utm_medium) {
			body.utm_medium = params.utm_medium;
		}
		if (params.utm_term) {
			body.utm_term = params.utm_term;
		}
		if (params.utm_content) {
			body.utm_content = params.utm_content;
		}
		if (params.utm_campaign) {
			body.utm_campaign = params.utm_campaign;
		}
		const queries = new URLSearchParams(body).toString();
		// console.log("Q", queries);
		this.props.postConfirm(phone, password, queries);
	}

	onChange = (event) => {
		//  TODO: use redux for state management
		const { value } = event.currentTarget;
		const { onChange } = this.props;
		onChange(this.toEnglishDigits(value));
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.onConfirm();
		}
	}

	toEnglishDigits = (str) => {
		// convert persian digits [۰۱۲۳۴۵۶۷۸۹]
		let e = '۰'.charCodeAt(0);
		str = str.replace(/[۰-۹]/g, (t) => {
			return t.charCodeAt(0) - e;
		});
		// convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
		e = '٠'.charCodeAt(0);
		str = str.replace(/[٠-٩]/g, (t) => {
			return t.charCodeAt(0) - e;
		});
		return str;
	}

	render() {
		const {
			password, phone, back, callConfirm, confirm, call
		} = this.props;
		return (
			<div className={styles.loginBox}>
				<>
					<div className={styles.imgContainer}>
						<img src={Logo} alt="logo" />
					</div>
					<h3 className={styles.loginText}>کد تایید را وارد نمایید</h3>
					<p className={`${styles.titleText} text-muted`}>کد تایید برای شماره موبایل {phone} ارسال گردید <span onClick={back} className={styles.edit}>(ویرایش شماره)</span></p>
					<input
						type="password"
						autoFocus
						className={styles.numberInput}
						onChange={this.onChange}
						value={password}
						placeholder="-   -   -   - "
						onKeyPress={this.handleKeyPress}
					/>
					{
						confirm && confirm.confirm && confirm.confirm.error && <div className={styles.error}>{confirm.confirm.error[0]}</div>
					}
					<div className={styles.counter}>
						<CountdownTimer seconds={this.seconds} timer={this.seconds} callConfirm={callConfirm} phone={phone} />
					</div>
					{confirm.loading ? <Loader /> : <div className={styles.btnLogin} onClick={this.onConfirm}> ورود</div>}
				</>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		confirm: state.confirm,
		call: state.call,
	};
};
export default connect(mapStateToProps, { postConfirm, postCall })(LoginConfirm);
